import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

const start = (name?: string) => http.post(API_ENDPOINTS.accessReviews, { name });

const list = () => http.get(API_ENDPOINTS.accessReviews);

const get = (id: number | string) => http.get(`${API_ENDPOINTS.accessReviews}/${id}`);

const certify = (id: number | string, entryIds?: number[]) =>
  http.post(`${API_ENDPOINTS.accessReviews}/${id}/certify`, { entryIds });

const revoke = (id: number | string, entryIds?: number[]) =>
  http.post(`${API_ENDPOINTS.accessReviews}/${id}/revoke`, { entryIds });

const complete = (id: number | string) => http.post(`${API_ENDPOINTS.accessReviews}/${id}/complete`);

const downloadRecord = async (id: number | string, filename: string): Promise<void> => {
  const blob: any = await http.get(`${API_ENDPOINTS.accessReviews}/${id}/record`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const AccessReviewService = { start, list, get, certify, revoke, complete, downloadRecord };

export default AccessReviewService;
